
      
   <template>
      <div>
         <div class="company-list-b">
    <!-- header -->
    <div class="ui secondary menu header-list">
        <h2 class="header item">
            شرکت های برتر
        </h2>
        <div class="menu filter-bar" style="margin-right: 0px !important">
            <!-- company activity -->
            <div class="ui multiple search normal selection dropdown item multiple-select">
                <input type="hidden" @change="loadCompanies($event, 'company_activity')">
                <i class="dropdown icon"></i>
                <h6 class="default text">حوزه فعالیت</h6>
                <div class="menu">
                    <div class="item" v-for="act in this.companyActivites" :value="act.key" :data-value="act.key">
                        {{act.value}}
                    </div>
                </div>
            </div>
            <!-- company location -->
            <div class="ui multiple search normal selection dropdown item multiple-select">
                <input type="hidden" @change="loadCompanies($event, 'location')">
                <i class="dropdown icon"></i>
                <h6 class="default text">همه موقعیت مکانی</h6>
                <div class="menu">
                    <div class="item" v-for="loc in copmpanyLocations" :data-value="loc.id">
                        {{loc.state + ' - ' + loc.city}}
                    </div>
                </div>    
            </div>
        </div>
        <!-- search bar -->
        <div class="menu search-box">
            <div class="item" style="width: 18em; padding: 0px !important;">
                <div class="ui icon input">
                    <input type="text" placeholder="جستجو در عنوان شرکت ..." @keyup.enter="loadCompanies()"
                        v-model="search.title">
                    <i class="search icon"></i>
                </div>
            </div>
        </div>
    </div>
    <!-- company's list -->
    <div class="ui basic segment">
        <!-- loading -->
        <div class="ui active inverted dimmer" v-if="loading">
            <div class="ui text loader">بارگذاری</div>
        </div>
        <!-- not found -->
        <not-found v-if="!company_list || this.company_list.length === 0"></not-found>
        <div class="company_list_body">
            <!-- company list -->
            <div v-for="company in company_list" class="ui raised segment company-info company_shadow">
                <!-- company image -->
                <img class="company_list_company_image" :src="company.logo" alt="company_list_image">
                <!-- company name -->
                <h4 v-text="company.title"></h4>
                <!-- company location -->
                <p v-text="company.location"></p>
                <!-- company activity -->
                <p v-text="company.company_activity"></p>
                <!-- show company info -->
                <button class="ui violet button" @click="goToCompany(company.pk)">مشاهده جزییات</button>
            </div>
        </div>
    </div>
</div>
      </div>
   </template>
   
   <script>
      import not_found from '../../../../static/components/not_found.vue';

      export default {
  props: {
    context: Object,
  },
  data() {
    // informations that is going to be shown for every company
    return {
      company_list: [],
      loading: false,
      companyActivites: [],
      copmpanyLocations: [],
      search: {
        location: [],
        company_activity: '',
        title: undefined,
        companyActivites: [],
        copmpanyLocations: [],
      },
      picture_field: [
        {
          source: '',
          name: "لوگو شرکت",
        },
      ],
      company_list: [
        {
          title: "نام شرکت",
          name: "company_name",
          t_class: "eight wide column",
          value: '',
        },
        {
          title: "حوزه فعالیت شرکت",
          name: "company_activity",
          t_class: "",
          value: '',
        },
        {
          title: "شهر",
          name: "company_city",
          t_class: "",
          value: '',
        },
      ],
    };
  },
  // call api 
  async created() {
    console.log("context:", this.context);
    this.loadCompanies();
    // =>load company activities
    this.companyActivites = await getConfig('company_activity');
    if (!this.companyActivites) {
      this.companyActivites = [];
    }
    // =>load company locations
    let res = await callStdAPI(this.context.companyLocationApi, { method: 'get' });
    // =>if success
    if (res.status === 200) {
      this.copmpanyLocations = res.data;
    }
  }, 
  mounted() {
    setTimeout(() => {
      $('.multiple-select').css('height', '39px');
    }, 200);
  },
  methods: {
    goToCompany(pk){
      window.open(this.context.url.replace('0', pk), '_blank');
    },
    async loadCompanies(event, type) {
      // =>normalize company activies
      if (type === 'company_activity' && typeof event.target.value === 'string') {
        this.search.companyActivites = event.target.value.split(',');
      }
      // =>normalize company locations
      if (type === 'location' && typeof event.target.value === 'string') {
        this.search.copmpanyLocations = event.target.value.split(',').map(i => Number(i));
      }
      // =>set loading
      this.loading = true;
      let data = {};
      // =>fill data object
      if (typeof this.search.title === 'string' && this.search.title.trim().length > 0) {
        data['title'] = this.search.title;
      }
      if (this.search.copmpanyLocations.length > 0 && this.search.copmpanyLocations[0] !== 0) {
        data['location'] = this.search.copmpanyLocations;
      }
      if (this.search.companyActivites.length > 0 && this.search.companyActivites[0] !== "") {
        data['company_activity'] = this.search.companyActivites;
      }
      // =>call company api
      let res = await callStdAPI(this.context.company_api, {
        method: "post",
        data: data,
      });
      // =>if success
      if (res.status === 200) {
        this.company_list = res.data;
        this.set_activity()
        this.loading = false;
      }
    },
    async set_activity() {
      for (const company of this.company_list) {
        if (company.company_activity !== '') {
          for (const item of this.companyActivites) {
            if (item.key === company.company_activity) {
              company.company_activity = item.value
            }
          }
        }
      }
    },
    redirect(url, pk) {
      redirect(url, pk)
    },
  },
  components: {
    'not-found': not_found
  },
};

   </script>

   <style scoped>
      .company-list-b {
  width: 95%;
  margin: 175px 2.5% 2.5%;
  border-radius: 15px;
  background-color: #ffffff;
}
.company-list-b .header-list {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100% !important;
  margin-bottom: 0px !important;
  padding-top: 25px !important;
}
.company-list-b .header-list h2 {
  padding: 0px !important;
}
.company-list-b .header-list .search-box {
  margin-right: 0px !important;
  margin-left: 0px !important;
}
.company-list-b .header-list .search-box input {
  font-size: 13px !important;
  font-weight: 800 !important;
}
.company-list-b .header-list .menu {
  margin-right: auto;
}

.filter-bar h6 {
  color: rgba(191, 191, 191, 0.87) !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  padding: 10px !important;
}

.multiple-select {
  border: 1px solid rgba(34, 36, 38, 0.15) !important;
  max-width: 195px !important;
  display: flex;
  flex-wrap: wrap;
  height: 100% !important;
  padding: 0px !important;
}
.multiple-select i {
  margin: 3px 1px !important;
}
.multiple-select h6 {
  padding: 6px !important;
}

.company-list-div {
  background-color: #ffffff !important;
  padding: 0px !important;
  margin: 0px !important;
}

.company_list_body {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0px 5% 1%;
}
.company_list_body .company-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-radius: 9px;
  padding: 10px;
  margin: 15px;
  box-shadow: 0 5px 25px 4px rgba(0, 0, 0, 0.06);
  border: none;
  transition: all 0.3s;
  width: 250px;
  min-width: 220px;
}
.company_list_body .company-info h4 {
  text-align: center !important;
}
.company_list_body .company-info img {
  width: 200px;
  height: 200px;
  border-radius: 35px;
  object-fit: cover;
  margin: 10px;
  margin: 10px;
}
.company_list_body .company-info button {
  margin-bottom: 10px !important;
}
.company_list_body .company-info:hover {
  box-shadow: 0 16px 25px 4px rgba(0, 0, 0, 0.13);
  transition: 1s;
}
.company_list_body .company_shadow {
  box-shadow: 0 16px 25px 4px rgba(0, 0, 0, 0.12) !important;
}

h1 {
  background-color: #ffffff;
  width: 100%;
  padding-right: 3%;
  margin-bottom: 0 !important;
  padding-top: 2%;
}

.ui.menu:after {
  display: none !important;
}

@media only screen and (min-width: 470px) and (max-width: 950px) {
  .company_list_body {
    padding-top: 0px !important;
  }
  .header-list {
    flex-direction: column !important;
    align-items: center !important;
    margin-bottom: 0px !important;
  }
  .header-list .menu {
    margin-right: 0px !important;
  }
  .header-list .search-box {
    margin-right: 0px !important;
  }
  .filter-bar {
    margin: 20px 0px !important;
  }
}
@media only screen and (max-width: 470px) {
  .company_list_body {
    padding: 0px !important;
  }
  .company_list_body .company-info {
    margin: 5% !important;
    width: 90% !important;
  }
  .company-list-b {
    margin-top: 150px !important;
  }
  .multiple-select {
    margin: 1% 0px !important;
  }
  .header-list {
    flex-direction: column !important;
    align-items: center !important;
    margin-bottom: 0px !important;
  }
  .header-list .menu {
    margin-right: 0px !important;
  }
  .header-list .search-box {
    margin-right: 0px !important;
  }
  .filter-bar {
    flex-direction: column !important;
    margin: 20px 0px !important;
  }
}
@media only screen and (max-width: 700px) {
  .company-info {
    min-width: none !important;
    width: 80% !important;
  }
  .company-info button {
    width: 100% !important;
    height: 50px !important;
  }
}

   </style>
    
  
   